module.exports = __webpack_public_path__ + "img/serious-dice-200.ad47175a.png";